goog.provide('el8.appchart.reportFeeds.expandFn');

goog.require('el8.app.shared.documentImageRenderer');
goog.require('el8.appchart.visitNote.main');
goog.require('el8.apphome.docMgr.util');
goog.require('el8.appservice.notifier');
goog.require('el8.model.identify');
goog.require('el8.ptdata.model.documentImage');
goog.require('el8.ptdata.model.noteItem');
goog.require('el8.service.tooltip');
goog.require('el8.template.appchart.reportFeeds');
goog.require('el8.util.consts');
goog.require('el8.util.feed');

el8.appchart.reportFeeds.expandFn = function(item, divElt) {

    if (el8.model.identify.isReport(item) || el8.model.identify.isNote(item)) {

        var imageHeight = 666;
        // width is min of 300, max of 650
        var imageWidth = Math.max(Math.min(650, $('.cardDetails', divElt).width()), 300);

        if (!item.isImagesLoaded()) {
            item.setImagesLoaded(true);
            var $imageFeedElt = $('.report-images, .visit-image-section, .nonvisit-image-section', divElt);
            if ($imageFeedElt.length) {

                if (el8.model.identify.isNonvisitNote(item)) {
                    // I don't know why nonvisits work differently...
                    el8.util.feed.loadImages({
                        item: item,
                        images: item.getImages(),
                        container: divElt,
                        width: '100%',
                        zoomable: true
                    });
                } else {
                    var imageSpec = {
                        imageHeight: imageHeight,
                        imageWidth: imageWidth
                    };
                    var feed = el8.app.shared.documentImageRenderer(item, imageSpec, $imageFeedElt);
                    feed.display();
                }
            }
        }
    }

    if (el8.model.identify.isReport(item)) {
        /**
         * Need to activate report note / report addendums section
         */

        if (el8.model.identify.isPatientFormCollection(item)) {
          el8React.render.medicalFormFeedItem(
            "react-medical-form-feed-item" + "-" + item.getFeedItemId(),
            { id: item.getId() }
          );
        }

        if (!item.isNotesLoaded()) {
            item.setNotesLoaded(true);
            if (!item.isSignedOff()) {

                // If report not yet signed off, we add a listeditor
                var infoField = el8.service.infoField.addInfoField({
                    field: $('textarea[name="report-note"]', divElt),
                    infoText: 'Add notes here...'
                });
                var listeditor = new el8.uiwidget.listeditor({
                    editFriendly: true,
                    list: $('.report-note-list', divElt),
                    getItemIdFn: function(_item) { return _item.getId(); },
                    getItemTextFn: function(_item) { return _item.getText(); },
                    saveFn: function(id, val, index, opts) {
                        var noteItem = id ? item.getNoteItemById(id) :
                            el8.ptdata.model.noteItem({});
                        noteItem.setText(val);
                        item.saveNoteItem(noteItem, function(_item) {
                            el8.appchart.mainFeeds.reqAct.refreshItem(item);
                            if (opts.successCb) { opts.successCb(_item); }
                        }, opts.async);
                    },
                    removeFn: function(id) {
                        item.deleteNoteItem(id, function() {
                            el8.appchart.mainFeeds.reqAct.refreshItem(item);
                        });
                    }
                }).init(infoField);
                listeditor.addEntries(item.getNoteItems());

                el8.appchart.reportFeeds.listeditors[item.getId()] = listeditor;

            } else {

                var infoField = el8.service.infoField.addInfoField({
                    field: $('textarea[name="report-addendum"]', divElt),
                    infoText: 'Add report addendum here...',
                    height: el8.util.consts.DEFAULT_FIELD_HEIGHT
                });

                // Else, offer a textarea for writing additional addendums
                // (signed note items are already being displayed in the template)
                if (!el8Globals['TEASE']) {
                    $('button.submit-report-addendum', divElt).click(function(e) {
                        var text = infoField.getVal();
                        if (text) {
                            var newAddendum = el8.ptdata.addendums.create({
                                text: text,
                                referenced_document_id: item.getId()
                            });
                            el8.ptdata.addendums.saveItem(newAddendum, false, {
                                successCb: function() {
                                    infoField.setVal('');
                                    $('.referring-addendums', divElt).append(
                                        el8.template.ptdata.addendums.reportSummary({
                                            item: newAddendum.asSoyMap()
                                        })
                                    );
                                    item.addAddendumId(newAddendum.getId());
                                    el8.appchart.mainFeeds.chart.update();
                                }
                            });
                        } else {
                            el8.uiwidget.alert('Please add text before saving.');
                        }
                    });
                } else {
                    $('button.submit-report-addendum', divElt).prop('disabled', true);
                }
            }
        }

        /**
         * For lab results, need to render lab result grids
         */
        if (item.getReportType() === 'lab' && item.hasGrids()) {

            if (el8Globals['TEASE']) {
                $('ul.results', divElt).addClass('noAction');
            }

            if (!item.isGridsRendered()) {

                var addHovers = function($elt) {
                    // Add hover "reference range" messages
                    $elt.find('.labValue').each(function() {
                        var hoverMsg = el8.template.appchart.reportFeeds.qtipLabResult({
                            value: $(this).attr('value'),
                            refRange: $(this).attr('refRange'),
                            abnormalDescription: $(this).attr('abnormalDesc'),
                            abnormalFlag: $(this).attr('abnormalFlag'),
                            documentingPersonnelName: $(this).attr('documenter'),
                            labFacilityName: $(this).attr('loc')
                        });
                        el8.service.tooltip.create({
                            anchor: $(this),
                            text: hoverMsg
                        });
                    });
                    // Add hover "reference range and date" messages to previous values
                    $elt.find('.labPreviousValue').each( function() {
                        var hoverMsg = $(this).attr('resultinfo');
                        el8.service.tooltip.create({
                            anchor: $(this),
                            text: hoverMsg
                        });
                    });
                };

                item.setGridsRendered(true);
                if (item.getResultGrids().length > 0) {
                    addHovers(divElt);
                }

                // If there's an open Visit Note, highlight all the lab values that have
                // been referenced in note, on first render of grid
                if (el8.appchart.visitNote.main.isOpen() && el8.appchart.visitNote.main.isTwoColComplex()) {
                    var labResultsReferenced = el8.appchart.visitNote.main.getLabResultsInProblemBullets(item.getId());
                    $('.result-row', divElt).removeClass('labResultHighlight');
                    labResultsReferenced.map(function(r) {
                        $('#labResult_'+r, divElt).addClass('labResultHighlight');
                    });
                }
            }


        }

        // If there's an open Visit Note and user is physician, add Report to it
        if (el8.data.currUser.isPhysician() && el8.appchart.visitNote.main.isOpen()
                && el8.appchart.visitNote.main.allowAddReference()) {
            el8.appchart.mgr.notes.addReference({item: item, isAutoGen: true});
        }
    }
};

